import script from "./DistrictsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DistrictsView.vue?vue&type=script&setup=true&lang=js"

import "./DistrictsView.vue?vue&type=style&index=0&id=b0d77d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0d77d98"]])

export default __exports__